import styled from 'styled-components'

export const MapSearchBarWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ![
      'loaded',
      'map',
      'setClickFeature',
      'setDimension',
      'dimension',
      'popup',
      'mapboxgl',
      'clickFeature',
      'setHoverFeature',
      'hoverFeature',
    ].includes(prop),
})`
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  width: 100%;
  max-width: 400px;
  padding: 0 16px;

  @media (max-width: 768px) {
    top: 12px;
    max-width: calc(100% - 24px);
    padding: 0 12px;
  }

  @media (max-width: 480px) {
    top: 8px;
    max-width: calc(100% - 16px);
    padding: 0 8px;
  }
`
